module.exports = __webpack_public_path__ + "img/logo_user_cuadrado.4d04d3c4.png";